module.exports = __webpack_public_path__ + "img/storfront-hero.png";